import script from "./HeaderNavInsights.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderNavInsights.vue?vue&type=script&setup=true&lang=js"

import "./HeaderNavInsights.vue?vue&type=style&index=0&id=2bdc0559&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bdc0559"]])

export default __exports__